import { FieldType, Filterable } from "Components/LabIZO/Tablizo";

export const FILTERABLES: Filterable[] = [
  {
    field: "_id",
    label: "Project",
    type: FieldType.text,
  },
  {
    field: "contexts.context",
    label: "Context",
    type: FieldType.text,
  },
];
